// extracted by mini-css-extract-plugin
export default {"container":"R4-z","heading":"S4-z","links":"T4-z","copy":"U4-z","subCopy":"V4-z","linksLeft":"W4-z","linksCenter":"X4-z","linksRight":"Y4-z","link":"Z4-z","onlyLink":"_4-z"};